import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem';
import { handleAssociadoChange } from '../../../../../store/reducers/associadoSlice';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';

const CampoInputRazaoSocial = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { social_name } = useSelector(state => state.associadoState)
    
    const handleChange = (name, value) => {
        dispatch(handleAssociadoChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("social_name")
    }

    return (
        <CampoInputTexto
            id="inputRazaoSocial"
            titulo="Razão social*"
            onChange={handleChange}
            name="social_name"
            value={social_name}
            label="obrigatório"
            required={true}
            disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputRazaoSocial
